import {
    Backup,
    InsertDriveFile,
    Done,
    ErrorOutline,
    Close
} from "@mui/icons-material"
import { H5, Body2, Body3 } from "../../themes/typography"
import "./ExcelUploader.css"

export default function ExcelUploader({
    fileInputRef,
    error,
    file,
    removeUploadedFile = () => { },
    handleFileInput = () => { },
    status,
    fullWidth = false,
    progress
}) {

    return (
        <div
            className="csv-upload-advanced"
            style={{ maxWidth: fullWidth ? "100%" : "400px" }}
        >
            {!file ? (
                <div
                    className='upload-zone'
                    onClick={() => fileInputRef.current?.click()}
                >

                    <div className="upload-content">
                        <Backup sx={{ fontSize: 48 }} color="tertiary" />

                        <H5>
                            Upload Excel File
                        </H5>

                        <Body2 fontWeight={400} color="var(--scrollbar-color)">
                            Click to select an excel file (.xls, .xlsx)
                        </Body2>
                    </div>
                </div>

            ) : (
                <div className={`file-preview ${status}`}>
                    <div className="file-info">
                        <div className="file-icon">
                            <InsertDriveFile sx={{ fontSize: 32 }} color="tertiary" />
                        </div>
                        <div className="file-details">
                            <Body3 fontWeight={400}>
                                {file.name}
                            </Body3>
                            <div className="file-size">
                                {(file.size / 1024).toFixed(2)} KB
                            </div>
                        </div>
                        <button className="reset-btn" onClick={removeUploadedFile}>
                            <Close sx={{ fontSize: 16 }} />
                        </button>
                    </div>

                    {status === "uploading" && (
                        <div className="progress-container">
                            <div className="progress-bar">
                                <div className="progress-fill" style={{ width: `${progress}%` }}></div>
                            </div>
                            <span className="progress-text">{progress}%</span>
                        </div>
                    )}

                    {status === "success" && (
                        <div className="status-message success">
                            <Done sx={{ fontSize: 16 }} color="success" />
                            <Body3 fontWeight={400} color="var(--success-main-color)">
                                Upload completed successfully
                            </Body3>
                        </div>
                    )}

                    {status === "error" && (
                        <div className="status-message error">
                            <ErrorOutline sx={{ fontSize: 16 }} color="error" />
                            {error}
                        </div>
                    )}
                </div>
            )}

            <input
                ref={fileInputRef}
                type="file"
                accept=".xls, .xlsx"
                onChange={handleFileInput}
                style={{ display: "none" }}
            />
        </div>
    )
}